import { combineReducers } from "redux";
import { createMerchantReducer } from "./reducers/createMerchantReducer";
import { editMerchantReducer } from "./reducers/editMerchantReducer";
import { getMerchantsReducer } from "./reducers/getMerchantsReducer";
import { getMerchantsOfPartnersReducer } from "./reducers/getMerchantsOfPartnersReducer";
import { authReducer } from "./reducers/authReducer";
import { otpReducer } from "./reducers/otpReducer";
import { resendOtpReducer } from "./reducers/resendOtpReducer";
import { createUserReducer } from "./reducers/createUserReducer";
import { merchantReducer } from "./reducers/merchantReducer";
import { outLetsByMerchantReducer } from "./reducers/outLetsByMerchantReducer";
import { outLetsByPartnerReducer } from "./reducers/outLetsByPartnerReducer";
import { outletDetailsReducer } from "./reducers/outletDetailsReducer";
import { getUsersReducer } from "./reducers/getUsersReducer";
import { getTerminalsReducer } from "./reducers/getTerminalsReducer";
import { merchantSummaryReducer } from "./reducers/merchantSummaryReducer";
import { userSummaryReducer } from "./reducers/userSummaryReducer";
import { getOutletsTerminalsReducer } from "./reducers/getOutletsTerminalsReducer";
import { getUsersByOutletId } from "./reducers/getUsersByOutlet";
import { getUsersTerminalsReducer } from "./reducers/getUsersTerminalsReducer";
import { getUsersTransactionsReducer } from "./reducers/getUsersTransactionsReducer";
import { getTsnTransactionsReducer } from "./reducers/getTsnTransactionsReducer";
import { getTerminalSummaryReducer } from "./reducers/getTerminalSummaryReducer";
import { getOutletSummaryReducer } from "./reducers/getOutletSummaryReducer";
import { editUserReducer } from "./reducers/editUserReducer";
import { editOutletReducer } from "./reducers/editOutletReducer";
import { addOutletReducer } from "./reducers/addOutletReducer";
import { getListOfCurrency } from "./reducers/getListOfCurrency";
import { addCurrencyReducer } from "./reducers/addCurrencyReducer";
import { getListOfBusinessCategory } from "./reducers/gitListOfBusinessCategory";
import { getListOfFilterSearchReducer } from "./reducers/getListOfFilterSearchReducer";
import { getCountriesCitiesReducer } from "./reducers/getCountriesCities";
import { ResetPasswordFirstLoginReducer } from "./reducers/resetPasswordAfterFirstLog";
import { AddTerminalReducer } from "./reducers/addTerminalReducer";
import { getMerchntTransactionsReducer } from "./reducers/getMerchantTransactionReducer";
import { DeleteTerminalReducer } from "./reducers/deleteTerminalReducer";
import { getMerchantTodayBalanceReducer } from "./reducers/getMerchantTodayBalanceReducer";
import { getTopUsedTerminalReducer } from "./reducers/getTopusedTerminalReducer";
import { getMerchantTransactionCountReducer } from "./reducers/getMerchantTransactionCountReducer";import { getMerchantCurrentPreviousReducer } from "./reducers/getCurrenetPreviousMonthReducer";
import { getMerchantUsedSchemeReducer } from "./reducers/getTranactionUsedSchemeReducer";
import { getTerminalsTransactionChartReducer } from "./reducers/getTerminalsTransactionChartReducer";
import { getOutletsTransactionChartReducer } from "./reducers/getOutletsTransactionChartReducer";
import { getMerchantAvailableTerminalReducer } from "./reducers/getMerchantAvailableTerminalReducer";
import { AddTerminalTmsCardReducer } from "./reducers/AddTerminalCardSchemeReducer";
import { AddTerminalRetailerReducer } from "./reducers/AddTerminalRetailerDataReducer";
import { editTerminalReducer } from "./reducers/editTerminalReducer";

import { getReconcilationHistoryReducer } from "./reducers/getReconcilationHistoryReducer";
import { createInvoiceReducer } from "./reducers/CreateInvoiceReducer";
import { merchantInvoicesReducer } from "./reducers/getInvoicesList";
import { recurringPaymentsListReducer } from "./reducers/getRecurringPaymentsListReducer";
import { getPaymentConfigReducer } from "./reducers/getPaymentConfigReducer";
import { addMerchantPaymentConfigurationReducer } from "./reducers/addMerchantPaymentConfig";
import { merchantInvoiceReducer } from "./reducers/getMerchantInvoiceReducer";
import { getInvoicePaymentUrlReducer } from "./reducers/getPaymentUrlReducer";
import { EditInvoiceStatusReducer } from "./reducers/editInvoiceStatusReducer";
import { transactionsFilterReducer } from "./reducers/getFilterTransactionReducer";
import { SendInvoiceNotificationReducer } from "./reducers/sendInvoiceNotificationReducer";
import { SendTransactionReceiptReducer } from "./reducers/sendTransactionReceiptReducer";
import { invoicesFilterReducer } from "./reducers/getFilterInvoicesReducer";
import { getReconciliationFilterReducer } from "./reducers/getFilterReconciliationReducer";
import paymentGatewayTransactionReducer from "./reducers/getPaymentGatewayTransReducer";
import dashboardDataReducer from "./reducers/paymentDashboard";
import { fetchDashboardData } from "./actions/paymentDashboard";
import paymentGatewayHighlightsReducer from "./reducers/paymentGatewayHighlightsReducer";
import payementMethodsReducer from "./reducers/getPaymentMethodReducer";
import geopayementReducer from "./reducers/getGeoPaymentReducer";
import paymentChartReducer from "./reducers/getPaymentChartReducer";
import { addApplePayConfigReducer } from "./reducers/addApplePayConfig";
import { updateCardConfigReducer } from "./reducers/updateCardConfigRed";
import { getMerchantPaymentConfigReducer } from "./reducers/getMerchantPaymentConfigReducer";
import { addUrpayConfigReducer } from "./reducers/addUrpayConfigReducer";
import { addCardConfigReducer } from "./reducers/addCardConfigReducer";
import { geturpayConfigReducer } from "./reducers/geturpayConfigReducer";
import { updateurpayConfigReducer } from "./reducers/updateUrpayConfigReducer";
import { forgotPwReducer } from "./reducers/forgotPwReducer";
import { accessApiwReducer, merchantSecretReducer } from "./reducers/accessApiReducer";
import { findAppleConfigReducer } from "./reducers/findAppleConfigReducer";
import { updateAppleConfigReducer } from "./reducers/updateAppleConfigReducer";
import { addNewMerchantReducer } from "./reducers/addNewMerchantReducer";
import { manafithReducer } from "./reducers/addmanafithConfigurationReducer";
import { addNewCustomerReducer } from "./reducers/addNewCustomerReducer";
import { recurringMerchantReducer } from "./reducers/recurringMerchantReducer";
import { getCustomerListReducer } from "./reducers/getCustomerListReducer";
import { addNewProductReducer } from "./reducers/addNewProductReducer";
import { getProductListReducer } from "./reducers/getProductListReducer";
import { DeleteProductReducer } from "./reducers/deleteProductReducer";
import getProductTemplatesReducer from "./reducers/getProductTemplatesReducer";
import getInvoicesByTemplateReducer from "./reducers/getInvoicesByTemplateReducer";
import { DeleteCustomerReducer } from "./reducers/deleteCustomerReducer";
import { editCustomerReducer } from "./reducers/editCustomersReducer";
import { editProductReducer } from "./reducers/editProductsReducer";
import { sadadConfigReducer } from "./reducers/sadadPaymentConfig";
import { getTerminalsListReducer } from "./reducers/getTerminalsListReducer";
import { TamaraReducer } from "./reducers/addtamarhreducer";
import { getAllCountryReducer } from "./reducers/getAllCountryReducer";
import { getAllCurrencyReducer } from "./reducers/getAllCurrencyReducer";

import { addNewCountryReducer } from "./reducers/addNewCountryReducer";
import { editCountryReducer } from "./reducers/editCountryReducer";
import { getAllCityReducer } from "./reducers/getAllCityReducer";
import { addNewCityReducer } from "./reducers/addNewCityReducer";
import { addNewCurrencyReducer } from "./reducers/addNewCurrencyReducer";
import { getAllTmsReducer } from "./reducers/getAllTmsReducer";
import { getAllBusinessCategoryReducer } from "./reducers/getAllBusinessCategory";
import { updateBusCatReducer } from "./reducers/updateBusinessCatReducer";
import { getAllRetailerReducer } from "./reducers/getAllRetailerReducer";
import { editRetailerReducer } from "./reducers/editRetailerReducer";
import { addRetailerReducer } from "./reducers/addRetailerReducer";
import { editCurrencyReducer } from "./reducers/editNewCurrencyReducer";
import { deleteCurrencyReducer } from "./reducers/deleteCurrencyReducer";
import { addBusinessCategoryReducer } from "./reducers/addBsCategoryReducer";
import { activateBusinessCategoryReducer } from "./reducers/activateBusCatReducer";
import { deactivateBusinessCategoryReducer } from "./reducers/deactivateBusCatReducer";
import { editCityReducer } from "./reducers/editCityReducer";
import { addTmsReducer } from "./reducers/addTmsReducer";
import { activateTMSReducer } from "./reducers/activateTmsReducer";
import { deactivateTmsReducer } from "./reducers/deactivateTmsReducer";
import { paymentGatewayTrxReducer } from "./reducers/PaymentGatewayTrxReducer";
import { partnerCrudReducer } from "./reducers/PartnerCrudReducer";
import { partnerAssignReducer } from "./reducers/PartnerPartnerReducer";
import { userCrudReducer } from "./reducers/userCrudReducer";
import { merchantOnlineRegisterReducer } from "./reducers/merchantOnlineRegisterReducer";
import { deleteMerchantReducer } from "./reducers/deleteMerchantReducer";
import { partnerReducer } from "./reducers/partnerReducer";
import { getAuditReducer } from "./reducers/getAuditLogReducer";
import { getAllPaymentGyListReducer } from "./reducers/getPaymentGyReducer";
import { getApplePayTrxReducer } from "./reducers/getApplePayTransactions";
import { getOnBoardingFilesReducer } from "./reducers/getOnboardingFilesReducer";
import { versionsCrudOperationsReducer } from "./reducers/addVersionReducer";
import { partnerThemeCrudOperationsReducer } from "./reducers/getPartnerThemeReducer";
import {
  getTrxReqReducer,
  getTrxResReducer,
} from "./reducers/getTrsReqResReducer";
import { editMerchantAvailableTerminalReducer } from "./reducers/editAvailableTerminalReducer";
import { ClickToPayReducer } from "./reducers/addClickToPayReducer";
import { amsThreatsReducer } from "./reducers/amsThreatsReducer";
import {
  AllSummaryThreadsReducer,
  DataByDateFromMerchantControlReducer,
  Top3DetectionNameFromMerchantControlReducer,
  Top5TerminalIdFromMerchantControlReducer,
} from "./reducers/threatsDashboardReducer";
import { getSdkLoginTokenReducer } from "./reducers/GetSdkTokenReducer";
import { TabbyReducer } from "./reducers/addTabbyReducer";
import { planReducer } from "./reducers/planReducer";
import { getPlanByIdReducer } from "./reducers/getPlanByIdReducer";
import { partnerPlanReducer } from "./reducers/partnerPlanReducer";
import { merchantRecurringReduces } from "./reducers/merchantRecurringReduces";
import { assignedPlansReducer } from "./reducers/assignedPlansReducer";
import statCardsReducer from "./reducers/statCardsReducer";
import planSummaryReducer from "./reducers/planSummaryReducer";
import planMerchantsReducer from "./reducers/planMerchantsReducer";
import recurringPlanMerchantReducer from "./reducers/recurringPaymentMerchantReducer";
import { assignPlansReducer } from "./reducers/assignPlansReducer";
import { removePlansReducer } from "./reducers/removePlansReducer";
import recurringPlanSchedulesReducer from "./reducers/recurringPlanSchedulesReducer";
import plansByAmountReducer from "./reducers/plansByAmountReducer";
import termsAcceptanceReducer from "./reducers/termsAcceptanceReducer";
import latestTermsReducer from "./reducers/recurringPaymentTermsReducer";
import paymentReminderReducer from "./reducers/paymentReminderReducer";
import sendPaymentLinkReducer from "./reducers/sendPaymentLinkReducer";
import summaryStatusReducer from "./reducers/summaryStatusReducer";
import { termsAcceptanceSummaryReducer } from "./reducers/termsAcceptanceSummaryReducer";
import updatePaymentStatusReducer from "./reducers/updatePaymentStatusReducer";
import recurringPaymentBulkActionsReducer from "./reducers/recurringPaymentBulkActionsReducer";
import { togglePlansReducer } from "./reducers/toggleMultiplePlanReducer";
import { createRecurringPlanReducer } from "./reducers/createRecurringPlanReducer";
import { updateRecurringPlanReducer } from "./reducers/updateRecurringPlanReducer";
import { deletePlanReducer } from "./reducers/deletePlanReducer";
import { invoiceSummaryReducer } from "./reducers/invoiceSummaryReducer";
import paymentResponseReducer from "./reducers/paymentResponseReducer";
import updateInstallmentStatusReducer from "./reducers/updateInstallmentStatusReducer";

import { postRecurringPaymentCardholderReducer } from "./reducers/postRecurringPaymentCardholderReducer";
import { updateRecurringPaymentCardholderReducer } from "./reducers/updateRecurringPaymentCardholderReducer";
import { removeMerchantReducer } from "./reducers/removeMerchantReducer";
import { feedReducer } from "./reducers/feedReducer";
import { getHostByContactReducer } from "./reducers/getHostByContactReducer";
import { addingThemeConfigReducer } from "./reducers/addingThemeConfigReducer";
import { getAllPartnersReducer } from "./reducers/getAllPartnersReducer";
import getAllPartnerHostsReducer from "./reducers/getAllPartnerHostsReducer";
import getPartnerHostDetailsReducer from "./reducers/getPartnerHostDetailsReducer";
import addPartnerHostReducer from "./reducers/addPartnerHostReducer";
import { updatePartnerHostReducer } from "./reducers/updatePartnerHostReducer";
import { updateThemeConfigReducer } from "./reducers/updateThemeConfigReducer";
import { triggerPaymentsReducer } from "./reducers/triggerPayments";
import cancelPaymentScheduleReducer from "./reducers/cancelPaymentScheduleReducer";
import refundPaymentScheduleReducer from "./reducers/refundPaymentScheduleReducer";
import { setCustomerSupportCredentialsReducer } from "./reducers/setCustomerSupportCredentialsReducer";
// import { getfeedActive } from "./reducers/FeedReducer";

export const appReducer = combineReducers({
  authReducer,
  otpReducer,
  resendOtpReducer,
  ResetPasswordFirstLoginReducer,
  getMerchantsReducer,
  getMerchantsOfPartnersReducer,
  createMerchantReducer,
  editMerchantReducer,
  createUserReducer,
  merchantReducer,
  invoiceSummary: invoiceSummaryReducer,
  partnerReducer,
  outLetsByMerchantReducer,
  outLetsByPartnerReducer,
  outletDetailsReducer,
  getUsersReducer,
  getTerminalsReducer,
  AddTerminalTmsCardReducer,
  AddTerminalRetailerReducer,
  AddTerminalReducer,
  getMerchantAvailableTerminalReducer,
  editMerchantAvailableTerminalReducer,

  feedReducer,
  recurringMerchantReducer,

  DeleteTerminalReducer,
  deleteMerchantReducer,
  editTerminalReducer,
  merchantSummaryReducer,
  userSummaryReducer,
  getOutletsTerminalsReducer,
  getUsersByOutletId,
  getUsersTerminalsReducer,
  getMerchntTransactionsReducer,
  getUsersTransactionsReducer,
  getTsnTransactionsReducer,
  getTerminalSummaryReducer,
  getOutletSummaryReducer,
  editUserReducer,
  editOutletReducer,
  addOutletReducer,
  getListOfCurrency,
  getListOfBusinessCategory,
  addCurrencyReducer,
  getCountriesCitiesReducer,
  getListOfFilterSearchReducer,

  transactionsFilterReducer,

  getMerchantTodayBalanceReducer,
  getTopUsedTerminalReducer,
  getMerchantTransactionCountReducer,
  getMerchantCurrentPreviousReducer,
  getMerchantUsedSchemeReducer,
  getTerminalsTransactionChartReducer,
  getOutletsTransactionChartReducer,
  getReconcilationHistoryReducer,
  getReconciliationFilterReducer,

  createInvoiceReducer,
  merchantInvoicesReducer,
  recurringPaymentsListReducer,
  invoicesFilterReducer,
  merchantInvoiceReducer,
  getPaymentConfigReducer,
  addMerchantPaymentConfigurationReducer,
  getInvoicePaymentUrlReducer,
  EditInvoiceStatusReducer,
  SendInvoiceNotificationReducer,
  sendTransactionReceipt: SendTransactionReceiptReducer,

  paymentGatewayTransactionReducer,
  paymentGatewayTrxReducer,
  dashboardDataReducer,
  fetchDashboardData,
  paymentGatewayHighlightsReducer,
  payementMethodsReducer,
  geopayementReducer,
  paymentChartReducer,
  addApplePayConfigReducer,
  updateCardConfigReducer,
  getMerchantPaymentConfigReducer,
  addUrpayConfigReducer,
  addCardConfigReducer,
  geturpayConfigReducer,
  updateurpayConfigReducer,
  forgotPwReducer,
  accessApiwReducer,
  merchantSecretReducer,
  findAppleConfigReducer,
  updateAppleConfigReducer,
  addNewMerchantReducer,
  manafithReducer,
  sadadConfigReducer,
  TamaraReducer,
  ClickToPayReducer,
  getTerminalsListReducer,
  paymentResponseReducer,
  ////
  addNewProductReducer,
  getProductListReducer,
  DeleteProductReducer,
  editProductReducer,
  getProductTemplatesReducer,
  getInvoicesByTemplateReducer,
  ////
  addNewCustomerReducer,
  getCustomerListReducer,
  DeleteCustomerReducer,
  editCustomerReducer,
  /////
  getAllCountryReducer,
  addNewCountryReducer,
  editCountryReducer,
  ///
  getAllCityReducer,
  addNewCityReducer,
  editCityReducer,

  ///
  addNewCurrencyReducer,
  getAllCurrencyReducer,
  editCurrencyReducer,
  deleteCurrencyReducer,
  ///
  getAllTmsReducer,
  addTmsReducer,
  activateTMSReducer,
  deactivateTmsReducer,
  ///
  getAllBusinessCategoryReducer,
  updateBusCatReducer,
  addBusinessCategoryReducer,
  activateBusinessCategoryReducer,
  deactivateBusinessCategoryReducer,
  ///
  getAllRetailerReducer,
  editRetailerReducer,
  addRetailerReducer,

  //
  partnerCrudReducer,
  partnerAssignReducer,

  userCrudReducer,

  merchantOnlineRegisterReducer,

  ////
  //deleteMerchantReducer
  //
  getAuditReducer,
  //
  getAllPaymentGyListReducer,
  //
  getApplePayTrxReducer,
  //
  versionsCrudOperationsReducer,

  //
  partnerThemeCrudOperationsReducer,
  getOnBoardingFilesReducer,
  //TRX RQ RS
  getTrxReqReducer,
  getTrxResReducer,
  amsThreatsReducer,
  AllSummaryThreadsReducer,
  Top5TerminalIdFromMerchantControlReducer,
  Top3DetectionNameFromMerchantControlReducer,
  DataByDateFromMerchantControlReducer,
  getSdkLoginTokenReducer,
  TabbyReducer,
  planReducer,
  getPlanByIdReducer,
  partnerPlanReducer,
  merchantRecurringReduces,
  assignedPlansReducer,
  statCardsReducer,
  planSummary: planSummaryReducer,
  planMerchants: planMerchantsReducer,
  merchants: recurringPlanMerchantReducer,
  assignPlansReducer,
  removePlansReducer,
  schedules: recurringPlanSchedulesReducer,
  plansByAmount: plansByAmountReducer,
  termsAcceptance: termsAcceptanceReducer,
  latestTermsReducer,
  paymentReminder: paymentReminderReducer,
  paymentLink: sendPaymentLinkReducer,
  summaryStatus: summaryStatusReducer,
  termsAcceptanceSummaryReducer,
  updatePaymentStatus: updatePaymentStatusReducer,
  bulkActions: recurringPaymentBulkActionsReducer,
  togglePlansReducer,
  createRecurringPlanReducer,
  updateRecurringPlanReducer,
  deletePlanReducer,
  updateInstallmentStatusReducer,
  postRecurringPaymentCardholderReducer,
  updateRecurringPaymentCardholderReducer,
  removeMerchantReducer,
  getHostByContactReducer,
  addingThemeConfigReducer,

  // partner_host_reducers
  getAllPartnersReducer,
  getAllPartnerHostsReducer,
  getPartnerHostDetailsReducer,
  addPartnerHostReducer,
  updatePartnerHostReducer,
  updateThemeConfigReducer,
  triggerPayments: triggerPaymentsReducer,
  cancelPaymentSchedule: cancelPaymentScheduleReducer,
  refundPaymentSchedule: refundPaymentScheduleReducer,
  setCustomerSupportCredentialsReducer,
});

export const rootReducers = (state: any, action: any) => {
  if (action.type === "LOG_OUT") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export type RootState = ReturnType<typeof rootReducers>;
